
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.707 12.703c-2.503 0-4.482-.438-5.428-1.2l-.019-.015-.016-.017a.77.77 0 01-.202-.81l.008-.024a.784.784 0 01.716-.492c.64-.01 1.2-.087 1.709-.235-.811-.378-1.374-1.03-1.71-1.976a.7.7 0 01.245-.817.714.714 0 01.213-.109 4.73 4.73 0 01-.97-1.738l-.006-.02-.004-.02c-.063-.316.078-.641.338-.782a.726.726 0 01.346-.097 3.658 3.658 0 01-.277-.843c-.153-.79-.026-1.58.376-2.35L1.119.97a.52.52 0 01.83-.134l.17.17c1.339 1.403 2.538 2.07 4.612 2.525a3.674 3.674 0 01.992-2.118A3.48 3.48 0 0110.207.319h.006c.687 0 1.539.392 2.054.668.442-.144.975-.368 1.527-.605a.698.698 0 01.78.137c.2.2.255.48.15.754-.04.112-.086.221-.137.329a.7.7 0 01.203.14c.177.177.25.453.188.705l-.007.024c-.212.682-.618 1.238-1.156 1.587-.09 4.783-3.692 8.645-8.107 8.645zm-4.585-1.69c.892.504 2.592.81 4.585.81 1.917 0 3.725-.823 5.092-2.317C12.178 8 12.937 6 12.937 3.874V3.85c0-.192.106-.368.276-.458.346-.183.627-.495.809-.895a.516.516 0 01-.496-.203.516.516 0 01-.004-.614c.072-.1.138-.203.196-.31-.477.2-.93.38-1.323.5a.563.563 0 01-.433-.047c-.7-.39-1.353-.623-1.746-.624-1.451.022-2.63 1.264-2.63 2.771a.517.517 0 01-.62.51c-2.39-.472-3.808-1.178-5.281-2.659a2.597 2.597 0 00-.171 1.52c.099.509.362 1.02.761 1.476a.517.517 0 01.05.617.515.515 0 01-.573.226 2.376 2.376 0 01-.484-.185c.308.668.837 1.286 1.503 1.742a.52.52 0 01-.332.945 2.332 2.332 0 01-.689-.149c.374.76.97 1.178 1.888 1.338a.52.52 0 01.154.97c-.782.415-1.638.637-2.67.692z"}})])
          )
        }
      }
    